import React, { FC } from 'react';
import { Medium } from "@/constants/mediums";
import ReadingsDetailPage from "@/components/readings/ReadingsDetailPage";

const GasReadingsDetailPage: FC = () => {
  return <ReadingsDetailPage medium={Medium.gas} />;
};

export default GasReadingsDetailPage;
